<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
    }
  }
</script>

<template>
    <div>
        <dl>
            <dt>Tipo de compra</dt>
            <dd>Passagem Aérea</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-6' : 'col-xs-12']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade | fixar2digitos }}</dd>
            </dl>

            <dl class="col-xs-6" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>R$ {{ item.valorEstimado | fixar2digitos }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Informar dados do passageiro (Nome completo, CPF, telefone e e-mail)</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <h4 class="m-t-none m-b">Dados da Viagem - Ida</h4>
        <div class="hr-line-dashed margin-top-5"></div>

        <div class="row">
            <dl class="col-xs-3">
                <dt>Origem</dt>
                <dd>{{ item.origemIda || '---' }}</dd>
            </dl>
            <dl class="col-xs-3">
                <dt>Destino</dt>
                <dd>{{ item.destinoIda || '---' }}</dd>
            </dl>
            <dl class="col-xs-2">
                <dt>Data</dt>
                <dd>{{ item.dataIda | formatarNumeroEmData }}</dd>
            </dl>
            <dl class="col-xs-2">
                <dt>Horário de saída</dt>
                <dd>{{ item.horarioIda || '---' }}</dd>
            </dl>
            <dl class="col-xs-2">
                <dt>Horário de chegada</dt>
                <dd>{{ item.horarioChegadaIda || '---' }}</dd>
            </dl>
        </div>

        <div v-if="!item.apenasIda">
            <h4 class="m-t-none m-b">Dados da Viagem - Volta</h4>
            <div class="hr-line-dashed margin-top-5"></div>

            <div class="row">
                <dl class="col-xs-3">
                    <dt>Origem</dt>
                    <dd>{{ item.origemVolta || '---' }}</dd>
                </dl>
                <dl class="col-xs-3">
                    <dt>Destino</dt>
                    <dd>{{ item.destinoVolta || '---' }}</dd>
                </dl>
                <dl class="col-xs-2">
                    <dt>Data</dt>
                    <dd>{{ item.dataVolta | formatarNumeroEmData }}</dd>
                </dl>
                <dl class="col-xs-2">
                    <dt>Horário de saída</dt>
                    <dd>{{ item.horarioVolta || '---' }}</dd>
                </dl>
                <dl class="col-xs-2">
                    <dt>Horário de chegada</dt>
                    <dd>{{ item.horarioChegadaVolta || '---' }}</dd>
                </dl>
            </div>
        </div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
          <dt>Outros detalhes (Restrições ou Condições Especiais)</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaPassagemAerea.vue